export const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    width: "100%",
    height: "100%",
    // overflowY: "auto",
    maxWidth: "100%",
    gap: 2,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    alignItems: "center",
    gap: 2,
  },
  paper: {
    padding: "16px",
    display: "flex",
    gap: "16px",
    flexDirection: "column",
    width: "100%",
  },
  headerBox: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "start", md: "center" },
    width: "100%",
    gap: "12px",
    textWrap: "nowrap",
  },
  tab: {
    fontSize: "16px",
    paddingBottom: "30px",
  },
  cardsBox: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    flexWrap: "wrap",
    gap: 2,
  },
  skeleton: {
    width: "100%",
    height: "58px",
    borderRadius: "6px",
  },
  boxGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 300px, 1fr)",
    width: "100%",
  },
  textfield: { width: { md: "300px", sm: "260px", xs: "160px" } },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  buttonCancelDialog: {
    backgroundColor: "background.textField",
    color: "text.primary",
  },
  searchInput: {
    width: { xs: "100%", md: "400px" },
    // minWidth: "300px",
  },
  stackPagination: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%", //fit-content",
    maxHeight: "58px",
    backgroundColor: "background.paper",
    padding: 1.5,
    gap: 1,
    borderRadius: 2,
  },
  iconBtns: { display: "flex", flexDirection: "row" },
};
